const ServingPlatterIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    aria-hidden
  >
    <rect x="7.69875" y="0.48" width="0.96" height="0.968571" stroke="black" strokeWidth="0.96" />
    <path d="M0.499687 8.67913H15.873" stroke="black" strokeLinecap="square" />
    <path d="M1.78031 8.67773V6.74916" stroke="black" strokeLinecap="square" />
    <path d="M14.5811 8.67773V6.74916" stroke="black" strokeLinecap="square" />
    <path
      d="M1.79688 7.02276C1.79688 7.02276 2.04174 5.8573 2.8165 4.59715C3.72828 3.11414 5.37396 1.5 8.21811 1.5C13.479 1.5 14.6394 7.0715 14.6394 7.0715"
      stroke="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.04447 9.70384C4.48186 9.20387 8.30841 11.9285 8.90734 11.9285C9.50627 11.9285 11.3689 9.51249 11.9604 9.70384C12.552 9.89519 12.2205 13.9512 12.2205 13.9512L10.8422 16.714C10.8422 16.714 3.60707 10.2038 4.04447 9.70384Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4641 14.7852L11.6992 17.254L13.0506 18.2713L14.8876 15.9449L13.4641 14.7852Z"
      fill="black"
    />
  </svg>
);

export default ServingPlatterIcon;
